function deleveryRemixWaterOpenMethods(canAddWaterMark, params, res) {
  const newRemixOpenParams = {}
  if (params.results.LIMIT_WATERMARK_CONTENT && params.results.INFO_WATERMARK_CONTENT_VALUE === '') {
    // 如果先决条件打钩了,水印服务器开启了,并且INFO没有内容,证明可能是新外链,可能是老外链水印没打勾,
    // 那么强行打勾,禁用,内容为水印服务器内容
    newRemixOpenParams.WATERMARK_CONTENT = true
    newRemixOpenParams.WATERMARK_CONTENT_DISABLE = true
    newRemixOpenParams.WATERMARK_CONTENT_VALUE = params.waterMarkText
  } else if (params.results.LIMIT_WATERMARK_CONTENT && params.results.INFO_WATERMARK_CONTENT_VALUE !== '') {
    // 如果先决条件打钩了,水印服务器开启了,并且INFO有内容,证明是老外链并且水印打钩了,
    // 那么强行打勾,禁用,内容为水印服务器内容
    newRemixOpenParams.WATERMARK_CONTENT = true
    newRemixOpenParams.WATERMARK_CONTENT_DISABLE = true
    newRemixOpenParams.WATERMARK_CONTENT_VALUE = params.waterMarkText
  } else if (res.value === 'true' && params.results.LIMIT_WATERMARK_CONTENT === false && params.results.INFO_WATERMARK_CONTENT_VALUE === '') {
    // 如果先决条件没打钩,水印服务器开启了,并且INFO没有内容,证明可能是新外链,可能是老外链水印没打勾,
    // 但是管理控制台开启强制水印,
    // 那么强行打勾,禁用,内容为水印服务器内容
    newRemixOpenParams.WATERMARK_CONTENT = true
    newRemixOpenParams.WATERMARK_CONTENT_DISABLE = true
    newRemixOpenParams.WATERMARK_CONTENT_VALUE = params.waterMarkText
  } else if (res.value === 'true' && params.results.LIMIT_WATERMARK_CONTENT === false && params.results.INFO_WATERMARK_CONTENT_VALUE !== '') {
    // 如果先决条件没打钩,水印服务器开启了,并且INFO有内容,证明是老外链并且水印打勾了,
    // 但是管理控制台开启强制水印,
    // 那么强行打勾,禁用,内容为水印服务器内容
    newRemixOpenParams.WATERMARK_CONTENT = true
    newRemixOpenParams.WATERMARK_CONTENT_DISABLE = true
    newRemixOpenParams.WATERMARK_CONTENT_VALUE = params.waterMarkText
  } else if (res.value === 'false' && params.results.LIMIT_WATERMARK_CONTENT === false && params.results.INFO_WATERMARK_CONTENT_VALUE === '') {
    // 如果先决条件没打钩,水印服务器开启了,并且INFO没有内容,证明可能是新外链,可能是老外链水印没打勾,
    // 并且管理控制台没有开启强制水印,
    // 那么不打勾,不禁用,内容为服务器内容
    if (params.results.INFO_IS_CHECKED_WATERMARK && params.results.INFO_IS_CHECKED_WATERMARK) {
      // 如果老链接水印打勾,并且没内容,那么证明是,创建外链时只是普通水印打勾了
      newRemixOpenParams.WATERMARK_CONTENT = true
    } else {
      newRemixOpenParams.WATERMARK_CONTENT = false
    }
    newRemixOpenParams.WATERMARK_CONTENT_DISABLE = false
    newRemixOpenParams.WATERMARK_CONTENT_VALUE = params.waterMarkText
  } else if (res.value === 'false' && params.results.LIMIT_WATERMARK_CONTENT === false && params.results.INFO_WATERMARK_CONTENT_VALUE !== '') {
    // 如果先决条件没打钩,水印服务器开启了,并且INFO有内容,证明是老外链并且水印打勾了,
    // 并且管理控制台没有开启强制水印,
    // 那么打勾,不禁用,内容为服务器内容
    newRemixOpenParams.WATERMARK_CONTENT = true
    newRemixOpenParams.WATERMARK_CONTENT_DISABLE = false
    newRemixOpenParams.WATERMARK_CONTENT_VALUE = params.waterMarkText
  } else {
    console.log('水印判断异常')
  }
  if (!canAddWaterMark && (!params.results.LIMIT_WATERMARK_CONTENT || (!params.results.LIMIT_WATERMARK_CONTENT && params.results.INFO_WATERMARK_CONTENT_VALUE !== ''))) {
    if (!params.results.LIMIT_WATERMARK_CONTENT && params.results.INFO_WATERMARK_CONTENT_VALUE !== '') {
      // 当不受管控,并且info有水印内容,那么证明该链接水印之前打过勾,那么不受控制
    } else {
      newRemixOpenParams.WATERMARK_CONTENT = false
    }
    newRemixOpenParams.WATERMARK_CONTENT_DISABLE = false
  }
  return Object.assign(params.results, newRemixOpenParams)
}
function deleveryRemixWaterCloseMethods(canAddWaterMark, params) {
  const newRemixCloseParams = {}

  if (params.LIMIT_WATERMARK_CONTENT_VALUE !== '') {
    newRemixCloseParams.WATERMARK_CONTENT_VALUE_SHOW = false
  } else {
    newRemixCloseParams.WATERMARK_CONTENT_VALUE_SHOW = true
  }
  if (params.LIMIT_WATERMARK_CONTENT === true) {
    // 如果先决条件打钩了,那么就算服务器水印服务没开启,也要强制打勾,禁用,内容为默认值或INFO内容
    newRemixCloseParams.WATERMARK_CONTENT = true
    newRemixCloseParams.WATERMARK_CONTENT_DISABLE = true
    newRemixCloseParams.WATERMARK_CONTENT_VALUE = params.LIMIT_WATERMARK_CONTENT_VALUE
      ? params.LIMIT_WATERMARK_CONTENT_VALUE
      : params.INFO_WATERMARK_CONTENT_VALUE
  } else if (params.LIMIT_WATERMARK_CONTENT === false) {
    // 如果先决条件没打钩并且服务器水印服务没开启,那么不打勾,不禁用,内容为默认值或INFO内容
    if (params.LIMIT_WATERMARK_CONTENT === false && params.INFO_WATERMARK_CONTENT_VALUE !== '') {
      // 如果先决条件没控制水印,Info又有内容,那么应该打勾
      newRemixCloseParams.WATERMARK_CONTENT = true
    } else {
      newRemixCloseParams.WATERMARK_CONTENT = false
    }
    newRemixCloseParams.WATERMARK_CONTENT_DISABLE = false
    newRemixCloseParams.WATERMARK_CONTENT_VALUE = params.LIMIT_WATERMARK_CONTENT_VALUE
      ? params.LIMIT_WATERMARK_CONTENT_VALUE
      : params.INFO_WATERMARK_CONTENT_VALUE
  } else {
    console.log('水印判断异常')
  }

  if (!canAddWaterMark && (!params.LIMIT_WATERMARK_CONTENT || (!params.LIMIT_WATERMARK_CONTENT && params.INFO_WATERMARK_CONTENT_VALUE !== ''))) {
    if (!params.LIMIT_WATERMARK_CONTENT && params.INFO_WATERMARK_CONTENT_VALUE !== '') {
      // 当不受管控,并且info有水印内容,那么证明该链接水印之前打过勾,那么不受控制
    } else {
      newRemixCloseParams.WATERMARK_CONTENT = false
    }
    newRemixCloseParams.WATERMARK_CONTENT_DISABLE = false
  }
  return Object.assign(params, newRemixCloseParams)
}

const deleveryRemixWater = function func(canAddWaterMark, params, res, name) {
  const newParams = {}
  if (name === 'getWaterMark') {
    if (res.startWatermark === true) {
      newParams.startWatermark = true
      newParams.waterMarkText = res.text
      newParams.results = params
      return newParams
    }
    newParams.startWatermark = false
    newParams.results = deleveryRemixWaterCloseMethods(canAddWaterMark, params)
    return newParams
  }
  newParams.results = deleveryRemixWaterOpenMethods(canAddWaterMark, params, res)
  return newParams
}

export default deleveryRemixWater
